class Fader {
  // ---------------------------------------------------------------------------------------------------------
  // --	Fader
  // ---------------------------------------------------------------------------------------------------------

  constructor() {
    this.fader = $(".fader");
  }

  hide(callback = null) {
    gsap.killTweensOf(this.fader);
    gsap.to(this.fader, 0.3, {
      alpha: 0,
      ease: "none",
      onComplete: () => {
        this.fader.css("pointer-events", "none");
        if (callback) callback();
      },
    });
  }

  show(callback = null) {
    gsap.killTweensOf(this.fader);
    gsap.to(this.fader, 0.3, {
      alpha: 1,
      ease: "none",
      onStart: () => {
        this.fader.css("pointer-events", "auto");
      },
      onComplete: () => {
        if (callback) callback();
      },
    });
  }

  changeCategory(cat = null) {
    //クラス削除
    this.fader.removeClass("cat1");
    this.fader.removeClass("cat2");
    this.fader.removeClass("cat3");
    this.fader.removeClass("cat4");
    this.fader.removeClass("cat5");

    //指定があれば変更
    if (cat) this.fader.addClass(cat);
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Fader;
